// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"256":"e7baea54","629":"3b0097aa","706":"e7baea54"}[chunkId] + ".chunk.css";
};